<template>
  <div class="modal-container clearfix">
    <div class="container">
      <img style="height: 25px;width: 25px;margin-top: 15px" src="@/assets/images/common/error.png"/>
      <pre style="max-height:200px;width:100%;overflow-y:auto;margin-left: 10px">{{message}}</pre>
    </div>
    <div class="modal-footer add-btn-box">
      <Button @click="close" >取消</Button>
      <Button type="primary" @click="cover" >强制完成</Button>
    </div>
  </div>
</template>

<script>
  export default {
    name: "Message",
    props: {
      conImport: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        message: ''
      };
    },
    methods: {
      setMessage(message) {
        this.message = message;
      },
      close() {
        this.$emit('close');
      },
      cover(){
        this.$emit('cover');
      }
    }
  };
</script>

<style>
  .container {
    display: flex;
    width: 100%;
  }
</style>